<div *ngIf="obsToasts.value$| async as toasts" class="toasts-wrapper">
	<calao-toast *ngFor="let toast of toasts" [id]="toast.id" [title]="toast.title" [description]="toast.description"
		[duration]="toast.duration" [buttons]="toast.buttons" [showDismissButton]="toast.showDismissButton"
		[canDismissAfter]="toast.canDismissAfter" (onDismiss)="onDismissToast($event)"
		(onResponse)="onResponse($event)"></calao-toast>
</div>